export class TokenResponseModel {
  accessToken!: string;
  refreshToken!: string;
}
